import { createApp } from 'vue'
import { createStore } from "vuex"
import { alert } from '@/store/modules/alert';
import { loader } from '@/store/modules/loader';
import { account } from '@/store/modules/account';
import { hosts } from '@/store/modules/hosts';
import { keys } from '@/store/modules/keys';
import { logs } from '@/store/modules/logs';
import { responscodes } from '@/store/modules/responscodes';
import { rulesbyamount } from '@/store/modules/rulesbyamount';
import { terminals } from '@/store/modules/terminals';
import { transactions } from '@/store/modules/transactions';
import { protocols } from '@/store/modules/protocols';


const store = createStore({
    modules: {
        alert,
        loader,
        account,
        hosts,
        keys,
        logs,
        responscodes,
        rulesbyamount,
        terminals,
        transactions,
        protocols
    }
});
createApp().use(store);
export default store;